import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../components/ActionMenu/ActionMenuItem';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import Form from '../../components/Form/Form';
import SpinnerOverlay from "../../components/Spinner/SpinnerOverlay";
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from '../../services/data.service';
import Unauthorized from './../Authentication/Unauthorized';
import ApplicationRoles_popup_CreateApplicationRole from './Popups/ApplicationRoles_popup_CreateApplicationRole';

const ApplicationRolesView: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleException, handleResult } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const navigate = useNavigate()

    useEffect(() => {
        getTableData()
    }, [])

    function getTableData() {
        setShowSpinner(true);
        DataService
            .get<any[]>(`api/v1/ApplicationRoles/`)
            .then(response => {
                setShowSpinner(false);
                setData(response);
            })
            .catch(e => {
                setShowSpinner(false);
                handleException(e)
            });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ApplicationRoles/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function hidePopup(applicationRoleId?: number) {
        setShowPopup(false)
        if (applicationRoleId) {
            getTableData()
            navigate('/plm/userManagement/applicationRole/' + applicationRoleId)
        }
    }

    const colInfos: IColInfo[] = [
        { title: 'Id', key: true, dataProp: 'id', dataType: 'number', visible: false },
        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date' },
    ];
    if (isAuthorizedFor(ApplicationFunctions.UpdateApplicationRole)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true), applicationFunctions:[ApplicationFunctions.CreateApplicationRole] }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, applicationFunctions: [ApplicationFunctions.DeleteApplicationRole] }],
            });
    }

    if (!isAuthorizedFor(ApplicationFunctions.ViewApplicationRole)) {
        return (<Unauthorized />);
    }

    return (
        <div className='main-content'>
            <Form>
                <Form.Header title="Application roles" >
                    <ActionMenu title="Actions">
                        <ActionMenuItem width={300} icon="fa fa-plus" iconVariant="success" title={"Create new Role"} onClick={() => { setShowPopup(true); }} appFunction={ApplicationFunctions.CreateApplicationRole} />
                    </ActionMenu>
                </Form.Header>
                <Form.Content>
                    <DataTable
                        name='dtApplicationRoles'
                        colInfos={colInfos}
                        tableData={data}
                        navigateTitle='Application role'
                        navigateUrl='/plm/UserManagement/ApplicationRole/'
                    />
                </Form.Content>
            </Form>
            {showSpinner && (<SpinnerOverlay />)}
            {showPopup && (<ApplicationRoles_popup_CreateApplicationRole show={showPopup} onHide={hidePopup} />)}
        </div>
    );
}
export default ApplicationRolesView;
